import { createContext } from "react";

export const UnitSwitchContext = createContext(null);
